const crockfordCode = '0123456789ABCDEFGHJKMNPQRSTVWXYZ';

/**
 * Only allows valid ulids.
 * First ten characters of ulid are crockford base32 encoded timestamp.
 *
 * @returns milliseconds since unix epoch
 */
export function decodeTime(id: string): number {
  let timestamp = BigInt(0);

  for (let i = 0; i < 10; i++) {
    timestamp += BigInt(crockfordCode.indexOf(id[i])) << BigInt(5 * (9 - i));
  }

  return Number(timestamp);
}
